import { useEffect, useState } from "react";
import { api } from "../lib/api";
import DoorCard from "../components/DoorCard";
import Reveal from "../components/Reveal";

export default function Artists() {
  const [artists, setArtists] = useState([]);

  useEffect(() => {
    api.get("/artists").then((r) => setArtists(r.data)).catch(() => {});
  }, []);

  return (
    <main data-testid="artists-page" className="pt-28 sm:pt-36">
      <div className="jm-container pb-24 sm:pb-32">
        <Reveal>
          <p className="jm-overline mb-5">Artistes & projets</p>
          <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-jm-bone leading-[1.08] max-w-3xl">
            Des univers singuliers, <em className="italic text-jm-brass">une trajectoire commune</em>
          </h1>
          <p className="mt-6 max-w-2xl text-jm-smoke leading-relaxed">
            Chaque projet possède son propre langage, sa propre couleur — tous partagent la même exigence :
            une musique libre et habitée.
          </p>
        </Reveal>

        <div className="mt-16 sm:mt-20 grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8" data-testid="artists-grid">
          {artists.map((a, i) => (
            <DoorCard key={a.id} artist={a} index={i} />
          ))}
        </div>
      </div>
    </main>
  );
}
